import React from 'react';
import { useAuth } from '../../context/AuthContext';
import './Perfil.css';

const TIPO_CUENTA_LABEL = { 1: 'Master', 2: 'Empresa', 3: 'Usuario Empresa' };

const fmt = (v) =>
  v == null || v === '' || String(v).toLowerCase() === 'null' ? '—' : String(v);

const InfoRow = ({ label, value, accent = false }) => (
  <div className="perfil-info-row">
    <span className="perfil-info-label">{label}</span>
    <span className={`perfil-info-value${accent ? ' perfil-info-value--accent' : ''}`}>
      {fmt(value)}
    </span>
  </div>
);

const SectionDivider = ({ title }) => (
  <div className="perfil-section-divider">
    <span>{title}</span>
  </div>
);

export default function Perfil() {
  const { user } = useAuth();

  const inicial = (user?.nombreCompleto || user?.nombreUsuario || 'U')
    .charAt(0)
    .toUpperCase();

  const tipoCuenta = TIPO_CUENTA_LABEL[user?.tipoCuenta]
    ?? (user?.tipoCuenta != null ? String(user.tipoCuenta) : null);

  const esMasterLabel = user?.esMaster == null ? null : user.esMaster ? 'Sí' : 'No';

  return (
    <div className="perfil-page">

      <div className="perfil-page-header">
        <h1 className="perfil-page-title">Mi Perfil</h1>
        <p className="perfil-page-subtitle">Información de tu cuenta en el sistema</p>
      </div>

      <div className="perfil-hero-card">
        <div className="perfil-hero-avatar-wrap">
          <div className="perfil-hero-avatar">{inicial}</div>
          <button type="button" className="perfil-hero-avatar-edit" aria-label="Editar foto">
            ✏
          </button>
        </div>
        <div className="perfil-hero-info">
          <div className="perfil-hero-nombre">{fmt(user?.nombreCompleto)}</div>
          <div className="perfil-hero-usuario">@{user?.nombreUsuario}</div>
         
        </div>
      </div>

      <div className="perfil-info-grid">
        <div className="perfil-card">
          <h2 className="perfil-card-title">
            <span className="perfil-card-title-icon">👤</span>
            Datos del usuario
          </h2>

          <div className="perfil-info-list">
            <InfoRow label="Nombre completo"  value={user?.nombreCompleto} />
            <InfoRow label="Nombres"          value={user?.nombres} />
            <InfoRow label="Apellido paterno" value={user?.apellidoPaterno} />
            <InfoRow label="Apellido materno" value={user?.apellidoMaterno} />
            <InfoRow label="Nombre de usuario" value={user?.nombreUsuario} />
          </div>
        </div>

        <div className="perfil-card">
          <h2 className="perfil-card-title">
            <span className="perfil-card-title-icon">🏢</span>
            Empresa
          </h2>

          <div className="perfil-info-list">
            <InfoRow label="Nombre de empresa" value={user?.nombreEmpresa}  accent />
            <InfoRow label="Sucursal asignada" value={user?.sucursalId}     accent />
          </div>

          <SectionDivider title="Acceso & Permisos" />

          <div className="perfil-info-list">
            <InfoRow label="Rol"           value={user?.rolNombre}  accent />
            <InfoRow label="Tipo de cuenta" value={tipoCuenta}      accent />
            <InfoRow label="Es master"     value={esMasterLabel}    accent />
          </div>

        </div>
      </div>
    </div>
  );
}
